import React, {useState} from 'react';
import {Translation, withTranslation, WithTranslation} from 'react-i18next';
import {Link} from "react-router-dom";

const ArticleIntro = (props: ArticleIntroProps) => {
    const initialPublishDate = new Date(props.publishTimeMillisUtc)
    const [publishDate, setPublishDate] = useState(initialPublishDate)

    return (
        <Translation>
            {t =>
                <div>
                    <h2>{props.title}</h2>
                    <p>{props.text}</p>
                    <div className="container d-flex">
                        <span className="me-auto">{publishDate.toLocaleString()}</span>
                        <Link to={'/article/' + props.id}>Читать далее</Link>
                    </div>
                </div>
            }
        </Translation>
    )
}

interface ArticleIntroProps extends WithTranslation {
    id: string;
    title: string;
    text: string;
    publishTimeMillisUtc: number;
}

export default withTranslation()(ArticleIntro)

